/* knowledge-card-header.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./knowledge-card-header.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton, LinkButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import EmailIcon from '@atlaskit/icon/core/email';
import { Inline, Stack } from '@atlaskit/primitives/compiled';
import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import { SainAction, useAnalytics, useSAINUsageCriteriaMet } from '../../common/controller/analytics';
import { messages } from '../../messages';
import { onKnowledgeCardLinkClick } from '../analytics';
import { onEmailCopy } from '../util';
var HeaderWrapper = {
  default: "_19bvpxbi _u5f3pxbi"
};
var PrimaryInfoWrapper = {
  default: "_1e0c1txw _1bsb1osq _4t3i1osq _2lx21bp4 _1bah1h6o"
};
var HeaderActionsWrapper = {
  default: "_1o9zidpf _18u01wug"
};
export var KnowledgeCardHeader = function KnowledgeCardHeader(_ref) {
  var name = _ref.name,
    email = _ref.email,
    profileUrl = _ref.profileUrl,
    profileLinkText = _ref.profileLinkText,
    media = _ref.media,
    orgText = _ref.orgText,
    additionalInfo = _ref.additionalInfo,
    onLinkClick = _ref.onLinkClick,
    headerActions = _ref.headerActions,
    testId = _ref.testId;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var emailTooltip = {
    position: 'bottom',
    content: formatMessage(messages.knowledge_cards_copy_email_address),
    hideTooltipOnClick: true
  };
  return /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    xcss: HeaderWrapper.default,
    testId: testId
  }, /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    alignInline: "start",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.200",
    alignBlock: "center"
  }, media, /*#__PURE__*/React.createElement(Stack, {
    space: "space.100",
    xcss: PrimaryInfoWrapper.default
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "small"
  }, name), orgText && orgText, additionalInfo))), /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    xcss: HeaderActionsWrapper.default
  }, headerActions, !!email && /*#__PURE__*/React.createElement(IconButton, {
    icon: function icon(props) {
      return /*#__PURE__*/React.createElement(EmailIcon, _extends({}, props, {
        color: "var(--ds-icon, #292A2E)"
      }));
    },
    label: formatMessage(messages.ai_answer_who_questions_hover_email_icon),
    onClick: function onClick() {
      fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        location: 'header-copy-email'
      })));
      fireSAINUsageEvent({
        metCriteria: SainAction.COPY_CLICKED
      });
      onEmailCopy(email);
    },
    isTooltipDisabled: false,
    tooltip: emailTooltip
  }), profileUrl && /*#__PURE__*/React.createElement(LinkButton, {
    href: profileUrl,
    onClick: function onClick(e) {
      fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        location: 'header-view-profile'
      })));
      fireSAINUsageEvent({
        metCriteria: SainAction.VIEW_PROFILE_CLICKED
      });
      onLinkClick === null || onLinkClick === void 0 || onLinkClick(e);
    }
  }, profileLinkText)));
};